import { getClientEnv } from "./tools";

/**
 * 小鹏广州总部的经纬度
 */
export const defLocation = {
  longitude: 113.384917,
  latitude: 23.159293,
};

/**
 * 充电VIP URL
 * @param location 经纬度对象
 * @param entry 渠道号
 */
export const chargeVipUrl = (
  location?: { lng: number; lat: number } | null,
  entry = "",
) => {
  const lng = location?.lng || defLocation.longitude;
  const lat = location?.lat || defLocation.latitude;

  const env = getClientEnv();
  const vipH5Url =
    {
      test: `http://static.test.xiaopeng.local/apps/charge-web/charge-vip.html?lng=${lng}&lat=${lat}&entry=${entry}#/`,
      deploy: `https://static.deploy-test.xiaopeng.com/apps/charge-web/charge-vip.html?lng=${lng}&lat=${lat}&entry=${entry}#/`,
      product: `https://static.xiaopeng.com/apps/charge-web/charge-vip.html?lng=${lng}&lat=${lat}&entry=${entry}#/`,
    }[env] || "";

  return vipH5Url;
};

export const CHARGE_CDN = "https://s.xiaopeng.com/xp-charge/mini";

export const P_MALL_APPID = "xp_ppstore"; // 商城H5

export const servicePhone = "4008193388"; // 客服电话

export const HOME_PILE_SHARE_VERSION = "4.52.0"; // 私桩共享app上线版本号

/**
 * 购买协议说明专题页 PageCode
 */
export const PURCHASE_AGREEMENT_PAGE_CODE = {
  test: "PAGE72946859",
  deploy: "PAGE61144180",
  product: "PAGE76648101",
}

/**
 * 会员规则说明专题页 PageCode
 */
export const VIP_RULES_PAGE_CODE = {
  test: "PAGE50314702",
  deploy: "PAGE21646977",
  product: "PAGE31103838",
}
